import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ZaloCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    const error = searchParams.get("error");
    const errorDescription = searchParams.get("error_description");
    const state = searchParams.get("state");

    // Gửi message về parent window (popup opener)
    if (window.opener) {
      if (error) {
        window.opener.postMessage(
          {
            type: "ZALO_AUTH_ERROR",
            error: errorDescription || error || "Đăng nhập Zalo thất bại",
            state: state,
          },
          window.location.origin
        );
      } else if (code) {
        window.opener.postMessage(
          {
            type: "ZALO_AUTH_SUCCESS",
            code: code,
            state: state,
          },
          window.location.origin
        );
      } else {
        window.opener.postMessage(
          {
            type: "ZALO_AUTH_ERROR",
            error: "Không nhận được mã xác thực từ Zalo",
            state: state,
          },
          window.location.origin
        );
      }

      // Đóng popup sau khi gửi message
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      // Nếu không phải popup, có thể redirect về trang login với thông báo lỗi
      console.error("Trang này chỉ được sử dụng trong popup OAuth");
      // Có thể redirect về trang login nếu cần
      // window.location.href = "/login";
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-gray-600">Đang xử lý đăng nhập Zalo...</p>
        <p className="text-sm text-gray-400 mt-2">
          Cửa sổ này sẽ tự động đóng sau vài giây
        </p>
      </div>
    </div>
  );
}